import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { prepareHeaders } from '../auth/entity/api/auth';
import { HubSpotToken } from 'src/config/api/models/Hubspot';

export const hubspotApi = createApi({
  reducerPath: 'hubspotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    getChatIdentifyToken: builder.mutation<HubSpotToken, void>({
      query: () => ({
        url: apiRoutesV2.getHubspotIdentificationToken(),
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetChatIdentifyTokenMutation } = hubspotApi;
